import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import Moment from 'moment'
import moment from 'moment-timezone';
import SearchComponent from '../../Search'
import { connect } from 'react-redux'
import Swal from 'sweetalert2'
const WebsiteBuyBox = (props) => {



    return (
        <>
            <Helmet>
                <title>Webiste Buybox</title>
                <link rel="stylesheet" href="../assets/css/style.css" />
                <script src="../assets/js/script.js" />
                <script src="../assets/plugins/apexchart/chart-data.js" />
            </Helmet>
            <div className="content">
                <h1>
                    Not Applicable
                </h1>
            </div>
        </>
    )
}
const mapStateToProps = state => ({
    isAuthenticated: state.Auth.isAuthenticated,
    user: state.Auth.user,
})

export default connect(mapStateToProps, {})(WebsiteBuyBox)